import { Box } from "@mui/system";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { allFilters } from "../../redux/actions/filterActions";
import { styles } from "./styles";
import IconComponent from "../Icon/IconComponent";
import { ICON_LABELS, fontSize, fontWeight } from "../../utils/constants/UI";
import { BRAND, GREY } from "../../utils/constants/colors";
import TypographyInline from "../Typography/TypographyInline";
import { STRINGS } from "../strings";

const FoundedOnFilter = ({ minFoundedOn, maxFoundedOn }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const allFiltersSelector = useSelector((state) => state.allFilters?.payload);

  const handleRemoveFilter = () => {
    const query = { ...allFiltersSelector };
    delete query.min_founded_on;
    delete query.max_founded_on;

    dispatch(allFilters(query, true));
    navigate({
      pathname: location.pathname,
      search: createSearchParams(query).toString(),
    });
  };

  return (
    <Box sx={styles.selectedFilterBox}>
      <div style={styles.cancelIcon} onClick={handleRemoveFilter}>
        <IconComponent
          iconLabel={ICON_LABELS.CANCEL}
          color={GREY.TERTIARY}
          fontSize={fontSize.MD}
        />
      </div>
      <div style={styles.filterValues}>
        <TypographyInline
          label={STRINGS.FOUNDED_ON}
          size="sm"
          fontWeight={fontWeight.SEMIBOLD}
          color={GREY.PRIMARY}
          isNoWrap
        />
        <TypographyInline
          label={STRINGS.IS_BETWEEN}
          size="sm"
          fontWeight={fontWeight.REGULAR}
          color={GREY.SECONDARY}
          isNoWrap
        />
        <TypographyInline
          label={`${minFoundedOn} and ${maxFoundedOn}`}
          size="sm"
          fontWeight={fontWeight.REGULAR}
          color={BRAND.PRIMARY}
          isNoWrap
        />
      </div>
    </Box>
  );
};

export default FoundedOnFilter;
